<template>
  <UserLayout :isContained="false">
    <!-- container-max-width -->
    <div class="">
      <div class="flex rounded-xl bg-smokeWhite">
        <div class="w-96 mt-20 ml-16">
          <p
            class="text-green-light header-font font-bold tracking-tight leading-17"
          >
            World-class workouts
          </p>
          <p class="text-5xl font-bold tracking-tight leading-17">
            by the world's best trainer
          </p>
          <p class="font-normal text-xl tracking-tighter leading-7 mt-10">
            Learn how you can start your fitness journey from the comfort your
            own home.
          </p>
          <!-- <button
            class="uppercase tracking-tight font-semibold text-white bg-green-light rounded-3xl py-2 px-8 mt-5"
          >
            Explore
          </button> -->
        </div>
        <img
          alt="home-banner"
          class="rounded-lg max-h-176 ml-5"
          @load="imgLoadHandler"
          :src="require(`@/assets/img/new-home-banner.webp`)"
        />
      </div>
      <section class="mt-24">
        <!-- Start of the Available classes section  -->
        <section>
          <div class="px-2 mb-2">
            <h6 class="text-3xl font-semibold tracking-tight leading-9">
              Available Classes
            </h6>
          </div>
          <AvailbaleSessions
            :data="
              userTrendingSessions &&
              userTrendingSessions.data &&
              userTrendingSessions.data.data
            "
            :statusCode="
              userTrendingSessions && userTrendingSessions.statusCode
            "
          />
        </section>

        <section>
          <div class="mt-20 mb-24 flex items-center justify-center">
            <h6 class="text-6xl font-semibold leading-18 tracking-tight">
              Coming Soon
            </h6>
          </div>
          <Carousel3d></Carousel3d>
        </section>

        <section class="mt-40">
          <div class="flex justify-between items-center">
            <div class="flex flex-col mr-4">
              <div class="font-semibold text-6xl tracking-tighter leading-17">
                <p class="text-green-light">Save time by working</p>
                <p>out from home</p>
              </div>
              <div class="mt-10 text-xl leading-7 tracking-tight font-normal">
                <p>
                  Find trainers with a schedule that fits yours and schedule a
                  class
                </p>
                <p>
                  before or after work or a last second class on the weekend
                </p>
              </div>
            </div>
            <div>
              <img
                :src="require(`@/assets/img/image16.webp`)"
                alt="image.png"
                class="rounded-3xl h-96"
                @load="imgLoadHandler"
              />
            </div>
          </div>
          <div class="flex flex-row-reverse justify-between items-center mt-40">
            <div class="flex flex-col ml-4">
              <div class="font-semibold text-6xl tracking-tighter leading-17">
                <p class="text-green-light">Find a fitness level</p>
                <p>that matches yours</p>
              </div>
              <div class="mt-10 text-xl leading-7 tracking-tight font-normal">
                <p>Maybe you are a beginner and just want to take a class with</p>
                <p>beginners. Fitclass is for you. Just pick a class type and pick</p>
                <p>a beginner level class</p>
              </div>
            </div>
            <div>
              <img
                :src="require(`@/assets/img/image15.webp`)"
                alt="image.png"
                class="rounded-3xl h-96"
                @load="imgLoadHandler"
              />
            </div>
          </div>
        </section>

        <!-- <section class="mt-32">
          <div class="flex justify-center items-center mx-96">
            <h6 class="text-6xl capitalize font-semibold text-center leading-18 tracking-tight">
              What our happy client says
            </h6>
          </div>
          <UserReviews />
        </section> -->

        <section class="mt-32">
          <div class="flex justify-center items-center">
            <h6 class="text-6xl font-semibold leading-18 tracking-tighter">
              Frequently asked questions
            </h6>
          </div>
          <FrequentlyAskedQuestions />
        </section>
      </section>
    </div>
  </UserLayout>
</template>

<script>
import UserLayout from "@/components/layouts/UserLayout";
// import NewHomeBannerImg from "@/components/NewHomeBannerImg";
import FrequentlyAskedQuestions from "@/components/FrequentlyAskedQuestions";
// import UserReviews from "@/components/UserReviews";
import NewUpcomingSessionsCard from "@/components/NewUpcomingSessionsCard";
import Carousel3d from "@/components/Carousel3d";
import TopCategoriesCardListCarousel from "@/components/TopCategoriesCardListCarousel";
import LiveSessionCardListCarousel from "@/components/user/LiveSessionCardListCarousel";
import TrendingSessionCardListCarousel from "@/components/TrendingSessionCardListCarousel";
import AvailbaleSessions from "@/components/AvailableSessions";
import RecommendedSessionCardListCarousel from "@/components/RecommendedSessionCardListCarousel";
import TrainerCardListCarousel from "@/components/user/TrainerCardListCarousel";
import UserTrainerPostListCarousel from "@/components/user/UserTrainerPostListCarousel";
import NewsLetter from "@/components/NewsLetter";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "NewHome",
  components: {
    FrequentlyAskedQuestions,
    // UserReviews,
    Carousel3d,
    AvailbaleSessions,
    UserLayout,
    // NewHomeBannerImg,
    NewUpcomingSessionsCard,
    TopCategoriesCardListCarousel,
    LiveSessionCardListCarousel,
    TrendingSessionCardListCarousel,
    RecommendedSessionCardListCarousel,
    TrainerCardListCarousel,
    UserTrainerPostListCarousel,
    NewsLetter
  },
  data() {
    return {
      currentPage: 1,
      LOADING: true,
      userTimezone: false,
      timezoneModalOpen: false,
      timezones: {},
      localUser: JSON.parse(localStorage.getItem("user")),
    };
  },
  computed: {
    ...mapGetters([
      "userUpcomingSessions",
      "userLiveSession",
      "userTrendingSessions",
      "userTrendingCourses",
      "userRecommendedSessions",
      "userRecommendedCourses",
      "userFollowedTrainerPosts",
      "categoriesList",
      "topTrainerList",
      "getTimezoneDetails",
    ]),
  },
  methods: {
    ...mapActions([
      "getUserUpcomingSessions",
      "getUserLiveSession",
      "getUserTrendingSessions",
      "getUserTrendingCourses",
      "getUserRecommendedSessions",
      "getUserRecommendedCourses",
      "getUserFollowedTrainerPosts",
      "getCategoriesList",
      "postTopTrainerList",
      "timezone",
    ]),

    imgLoadHandler() {
      this.LOADING = false;
    },
    updateTimezone() {
      // this.getUser().timezone = "oinve";
      this.timezoneModalOpen = false;
    },
  },
  async created() {
    if (this.getUser() && this.getUser().timezone) {
      this.userTimezone = true;
    }
    await this.timezone();
    this.timezones = this.getTimezoneDetails;
    const query = {
      page: this.currentPage,
    };
    // await this.getUserUpcomingSessions({ query });
    // this.getUserLiveSession({ query });
    this.getUserTrendingSessions({ query });
    // this.getUserTrendingCourses({ query });
    // this.getUserRecommendedSessions({ query });
    // this.getUserRecommendedCourses({ query });
    this.postTopTrainerList();
    this.getCategoriesList();
    if (this.getToken()) {
      this.getUserFollowedTrainerPosts({ query });
    }
  },
};
</script>

<style scoped>
.header-font {
  font-size: 3.75rem;
}
</style>
